var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vue-btn",class:_vm.getBackgroundClass,attrs:{"type":_vm.getType}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{class:_vm.getSpinnerClass})]),_vm._v(" "),(_vm.showSlot)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5543978f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/VueButtonSpinner.vue
// module id = null
// module chunks = 